var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",class:[
    { 'flex-column': !_vm.horizontal },
    { traslateEfect: _vm.traslate },
    { traslateEfectLoop: _vm.traslateSelected },
    { activeBtn: _vm.active },
    { inactiveBtn: _vm.inactive },
    { contenedor: !_vm.inactive },
    { contenedor_inactive: _vm.inactive },
  ],style:(_vm.btnStyle),attrs:{"title":_vm.tooltip}},[_c('i',{staticClass:"icon",class:[_vm.icon, { activeIcon: _vm.active, inactiveIcon: _vm.inactive }]}),_c('div',{staticClass:"text",class:{ 'ml-2': _vm.icon },domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }